import { ReactNode } from "react"

interface Props {
  path: string
  className?: string
  children: ReactNode
}

const REPO = "https://github.com/promptworks/stackup-ui"

export const GitHubLink = (props: Props) => {
  const { path, className, children } = props
  const href = path === "/" ? REPO : `${REPO}/blob/master${path}`

  return (
    <a className={className} href={href}>
      {children}
    </a>
  )
}
